/* eslint-disable no-undef */
import HistoryObserver from '../../services/history-observer/HistoryObserver';

class Gallery {
	GALLERY_LIST = '.gallery-list'; // Элемент списка
	GALLERY_LIST_ITEM = '.gallery-list__item'; // Коллекция слайдов
	GALLERY_BAR = '.gallery-nav'; // Элемент навигации
	BTN_FULLSCREEN = '.gallery-fullscreen'; // Кнопка "На весь экран"
	BTN_BAR = '.gallery-button'; // Кнопка навигации
	BTN_ARROW = '.gallery-arrow'; // Кнопка стрелок управления
	BTN_ARROW_NEXT = '.gallery-arrow[data-direction=next]'; // Кнопка прокрутки вперёд
	RADIO_LIST = '.gallery-preview'; // Элемент предпросмотра
	INP_RADIO = '.gallery-preview__item input[type=radio]'; // Инпут предпросмотра
	DOT = '.gallery-dots__item'; // Коллекция точек
	DESCRIPTION = '.gallery-description'; // Элемент описания слайда
	BACK_TO_START_BUTTON = '.gallery-list__item_last button'; // Кнопка "В начало галереи"
	GALLERY_OVERLAY = '.gallery-overlay'; // Фон галереи
	GALLERY_SPONSOR = '.gallery-sponsor '; // Блок рекламы на галерее
	GALLERY_SPONSOR_BUTTON = '.gallery-sponsor__close'; //  Кнопка закрытия блока рекламы

	/**
	 * Создает экземпляр Gallery.
	 * @param {string} [root='.gallery'] - можно передать класс или узел.*
	 *
	 * * *В случае с передачей класса будет выбран первый элемент на странице. (В остальных случаях инициализируется экземпляр на основе переданного узла)*
	 * @memberof Gallery
	 */
	constructor(root = '.gallery') {
		this.gallery = typeof root === 'string' ? document.querySelector(root) : root;

		if (!this.gallery) return;

		//- Служебные функции
		const select = (selector) => this.gallery.querySelector(selector);
		const selectAll = (selector) => this.gallery.querySelectorAll(selector);

		//- Элементы галереи
		this.galleryList = select(this.GALLERY_LIST);
		this.galleryListItems = selectAll(this.GALLERY_LIST_ITEM);
		this.galleryBar = select(this.GALLERY_BAR);
		this.btnFullscreen = select(this.BTN_FULLSCREEN);
		this.btnBar = select(this.BTN_BAR);
		this.btnsArrow = selectAll(this.BTN_ARROW);
		this.btnArrowNext = select(this.BTN_ARROW_NEXT);
		this.radioList = select(this.RADIO_LIST);
		this.inpRadios = selectAll(this.INP_RADIO);
		this.dots = selectAll(this.DOT);
		this.description = select(this.DESCRIPTION);
		this.startButton = select(this.BACK_TO_START_BUTTON);
		this.galleryOverlay = this.gallery.parentNode.querySelector(this.GALLERY_OVERLAY);
		this.gallerySponsor = select(this.GALLERY_SPONSOR);
		this.gallerySponsorButton = select(this.GALLERY_SPONSOR_BUTTON);
		this.galleryAds = select('.sponsor.ads-fotogal');

		//- Служебные значения
		this.isStartOnPage = true; // Если запущено на странице публикации типа "Галерея" с ID в URL страницы
		this.currentSlide = 0; // Текущий слайд
		this.nextSlide = this.currentSlide + 1; // Следующий слайд
		this.maxSlide = this.galleryList.children.length; // Последний слайд
		this.adCounter = 0; // Счётчик для обновления рекламы
		this.adCounterClick = 0;

		//- Навешиваем события на элементы управления
		this.handlerFullscreen();
		this.handlerEscapeFullscreen();
		this.hendlerClickEdge();
		this.handlerArrowButton();
		this.handlerNavigation();
		this.handlerPreview();
		this.handlerLetsDo();
		this.handlerAutoHideBar();
		this.handlerOvserver();
		this.handlerGoStart();
		this.handlerSponsorCloce();
	}

	//- Методы управления визуальным интерфейсом

	/**
	 * Вызывает прокрутку узла по направлению *direction*
	 *
	 * @param {*} direction - направление сдвига узгла
	 * @param {string} [type='instant'] - тип поведения прокрутки. По умолчанию *instant*, но может быть и *smooth*.
	 * @memberof Gallery
	 */
	move(direction, type = 'instant') {
		const stap = this.galleryList.children[1].offsetWidth * direction;

		this.galleryList.scrollBy({
			top: 0,
			left: stap,
			behavior: type,
		});
	}

	/**
	 * Вызывает прокрутку узла до нужной позиции.
	 * Расчёт нужной позиции происходит посредством произведения ширины элемента и индекса элемента в колеции.
	 *
	 * @param {*} id - индекса элемента в колеции
	 * @param {string} [type='instant'] - тип поведения прокрутки. По умолчанию *instant*, но может быть и *smooth*.
	 * @param {*} [root=this.galleryList] - колекция этементов. По умолчанию *this.galleryList*, но можно передать и другую колекцию.
	 * @param {number} [add=0] - дополнительный парамтр для рассчёта ширины прокрутки. Можно использовать для учёта *gap* (прибавляется к произведению ширины элемента и индекса элемента в колеции).
	 * @memberof Gallery
	 */
	moveTo(id, type = 'instant', root = this.galleryList, add = 0) {
		const stap = root.children[1].offsetWidth * id + add;

		root.scrollTo({
			top: 0,
			left: stap,
			behavior: type,
		});
	}

	/**
	 * Проверяет возможность дальнейшей прокрутки в заданном направлении
	 *
	 * @param {*} direction - направление
	 * @param {*} currentIndex - текущий индекс (позиция скрола)
	 * @param {*} maxIndex - максимальный индекс
	 * @return {*} Boolean
	 * @memberof Gallery
	 */
	canScroll(direction, currentIndex, maxIndex) {
		return !(currentIndex === 0 && direction === -1) && !(currentIndex === maxIndex && direction > 1);
	}

	/**
	 * Блокирует кнопку(и), если текущий индекс 0 или равен максимальному.
	 *
	 * @param {*} currentIndex - текущий индекс (позиция скрола)
	 * @param {*} maxIndex - максимальный индекс
	 * @memberof Gallery
	 */
	canClickArrowButton(currentIndex, maxIndex) {
		this.enableArrowButton('next');
		this.enableArrowButton('back');

		if (currentIndex === maxIndex) {
			this.disableArrowButton('next');
		}

		if (currentIndex === 0) {
			this.disableArrowButton('back');
		}
	}

	/**
	 * Выключает вкнопки в зависимости от переданного типа.
	 *
	 * @param {*} type - тип кнопки (next / back)
	 * @memberof Gallery
	 */
	disableArrowButton(type) {
		this.btnsArrow.forEach((btn) => {
			if (btn.dataset.direction === type) {
				btn.dataset.show = true;
			}
		});
	}

	/**
	 * Включает кнопки (стрелочки)
	 *
	 * @memberof Gallery
	 */
	enableArrowButton() {
		this.btnsArrow.forEach((btn) => {
			btn.dataset.show = false;
		});
	}

	/**
	 * Включает/выключает полноэкранный режим галереи
	 *
	 * @memberof Gallery
	 */
	toggleFullscreen() {
		document.body.style.overflow = document.body.style.overflow !== 'hidden' ? 'hidden' : null;
		document.querySelector('.header.container').classList.toggle('header_fullscreen');
		this.btnFullscreen.classList.toggle('open');
		this.btnFullscreen.setAttribute('aria-label', document.body.style.overflow !== 'hidden' ? 'На весь экран' : 'Свернуть');
		this.gallery.parentNode.classList.toggle('fullscreen');
	}

	//- Методы Set и Get

	/**
	 * Устанавливает новый индекс
	 *
	 * @param {*} nextIndex - индекс (текущая позиция скрола)
	 * @memberof Gallery
	 */
	setCurrentSlide(nextIndex) {
		this.nextSlide = nextIndex;
		this.currentSlide = Math.min(this.nextSlide, this.maxSlide);
	}

	/**
	 * Устанавливает текущий превью по ID
	 *
	 * @param {*} id - индекс (текущая позиция)
	 * @memberof Gallery
	 */
	setPreview(id) {
		this.inpRadios[id].checked = true;
		this.moveTo(id, 'smooth', this.radioList, -30);
	}

	/**
	 * Устанавливает номер текущего слайда с счётчик галереи, основываясь на текущем слайде (индексе)
	 * Обновлено Задача №: 1001655
	 *
	 * @memberof Gallery
	 */
	setCounter() {
		this.btnBar.children[0].innerText = `${this.currentSlide + 1}/${this.maxSlide}`;

		// Задача №: 1001655
		this.adCounterClick += 1;

		const isVisible = this.galleryAds.innerHTML.trim() !== '';

		if (isVisible) {
			const showAd = this.adCounterClick % 6 === 0 && this.adCounterClick != 0;
			if (showAd) {
				this.gallerySponsor.classList.toggle('show', showAd);
			}
		}

		const loadAd = (this.adCounterClick + 1) % 6 === 0 && this.adCounterClick != 0;
		console.log(this.adCounterClick);

		if (loadAd) {
			const container = this.gallery.querySelector('.sponsor.ads-fotogal');

			if (container && this.adCounter > 0) {
				const adId = `${this.adCounter >= 2 ? container.id.substring(0, container.id.lastIndexOf('-')) : container.id}-${this.adCounter}`;

				// чистим контейнер от старой рекламы
				container.innerHTML = '';
				// в строке ниже модифицируется идентификатор рекламного блока
				container.id = adId;
				// вызов рекламного блока использущий модифицированный идентификатор из предыдущей строки

				try {
					console.info('[ym] render');
					window.yaContextCb.push(() => {
						Ya.Context.AdvManager.render({
							blockId: 'R-A-592220-38',
							renderTo: adId,
						});
					});
				} catch (error) {
					console.error('[ym] error', error);
				}
			}

			this.adCounter += 1;
		}

		// Конец - Задача №: 1001655
	}

	/**
	 * Устанавливает текущую активную точку, основываясь на ID слайда (индексе)
	 *
	 * @param {*} id - индекс (текущая позиция)
	 * @memberof Gallery
	 */
	setDot(id) {
		this.dots.forEach((dot, key) => {
			const shouldBeActive = key === id;
			dot.classList.toggle('active', shouldBeActive);
		});
	}

	/**
	 * Устанавливает описание для слайда, основываясь на ID слайда (индексе)
	 *
	 * @param {*} id - индекс (текущая позиция)
	 * @memberof Gallery
	 */
	setText(id) {
		const galleryItem = this.galleryList?.children[id]?.children[0];
		const alt = galleryItem?.alt ?? '';
		const author = galleryItem?.dataset?.author;

		this.description.innerText = alt;

		if (author) {
			this.description.classList.remove('gallery-description_hide-author');
			this.description.dataset.author = author;
		} else {
			this.description.classList.add('gallery-description_hide-author');
		}
	}

	/**
	 * Получает индекс из URL страницы, когда пользователя переходит по ссылке с индексом
	 *
	 * @return {*} String
	 * @memberof Gallery
	 */
	getUrlId() {
		const url = window.location.href;
		const urlEnd = url.substring(url.lastIndexOf('/') + 1);
		return urlEnd.split('.')[0];
	}

	/**
	 * Возврвщает состояние галереи. *true * - полноекранная, *false* - обычное состояние
	 *
	 * @return {*} Boolean
	 * @memberof Gallery
	 */
	getFullscreenState() {
		return this.gallery.parentNode.classList.contains('fullscreen');
	}

	//- Обработчики событий

	/**
	 * Обработчик закрытия рекламы
	 * Задача №: 1001655
	 *
	 * @memberof Gallery
	 */
	handlerSponsorCloce() {
		this.gallerySponsorButton.addEventListener('click', (event) => {
			this.gallerySponsor.classList.remove('show');
		});
	}

	/**
	 * Обработчик нажатия на кнопку (кнопка стрелочка)
	 *
	 * @memberof Gallery
	 */
	handlerArrowButton() {
		this.btnsArrow.forEach((btn) => {
			btn.addEventListener('click', ({ currentTarget }) => {
				currentTarget.disabled = true;

				setTimeout(() => {
					currentTarget.disabled = false;
				}, 600);

				const direction = currentTarget.dataset.direction === 'back' ? -1 : 1;

				if (this.canScroll(direction, this.currentSlide, this.maxSlide)) {
					this.move(direction, 'smooth');
					this.btnArrowNext.classList.remove('lets-do');
				}
			});
		});
		this.canClickArrowButton(this.currentSlide, this.maxSlide);
	}

	/**
	 * Обработчик нажатия на кнопку навигации
	 * Сворачивает и разворачивает блок с навигацией
	 *
	 * @memberof Gallery
	 */
	handlerNavigation() {
		this.btnBar.addEventListener('click', ({ currentTarget }) => {
			const isOpen = this.galleryBar.dataset.open === 'true';
			isOpen ? (this.galleryBar.dataset.open = false) : (this.galleryBar.dataset.open = true);
			currentTarget.setAttribute('aria-label', isOpen ? 'Развернуть навигацию/подробности' : 'Свернуть навигацию/подробности');
		});
	}

	/**
	 * Обработчик нажатия на элемент предпросмотра
	 *
	 * @memberof Gallery
	 */
	handlerPreview() {
		this.inpRadios.forEach((inp) => {
			inp.addEventListener('click', (event) => {
				const id = event.currentTarget?.dataset?.id;

				this.moveTo(+id);
				this.setCurrentSlide(+id + 1);

				this.setText(this.currentSlide);
				this.canClickArrowButton(this.currentSlide, this.maxSlide);

				this.setDot(this.currentSlide);
				this.setCounter();

				this.btnArrowNext.classList.remove('lets-do');
			});
		});
	}

	/**
	 * Обработчик нажаия на кнопку "Развернуть на весь экран"
	 *
	 * @memberof Gallery
	 */
	handlerFullscreen() {
		this.btnFullscreen.addEventListener('click', () => this.toggleFullscreen());
		this.galleryList.addEventListener('dblclick', () => this.toggleFullscreen());
	}

	/**
	 * Обработчик блокировки кнопок на *300ms* для предоствращения накопления вызовов *move*
	 *
	 * @memberof Gallery
	 */
	handlerLetsDo() {
		setTimeout(() => {
			this.btnArrowNext.classList.add('lets-do');
		}, 3000);
	}

	/**
	 * Обработчик автоматического сворачивания блока навигации через *5000ms*, если пользователь не навел курсор в область галереи
	 *
	 * @memberof Gallery
	 */
	handlerAutoHideBar() {
		const timeout = setTimeout(() => {
			this.galleryBar.dataset.open = false;
		}, 5000);

		this.gallery.addEventListener('mouseenter', () => {
			clearTimeout(timeout);
		});
	}

	/**
	 * Обработчик нажатия на кнопку "В начало галереи". Возвращает на первый элемент галереи.
	 *
	 * @memberof Gallery
	 */
	handlerGoStart() {
		if (this.startButton) {
			this.startButton.addEventListener('click', () => {
				this.moveTo(0);
			});
		}
	}

	/**
	 * Обработчик нажатия кнопки Escape для сворачивания галереии из полноэкранного режима
	 *
	 * @memberof Gallery
	 */
	handlerEscapeFullscreen() {
		document.addEventListener('keydown', (event) => {
			if (event.code === 'Escape' && this.getFullscreenState()) {
				this.toggleFullscreen();
			}
		});
	}

	/**
	 * Обработчик события клика по краю полноэкранной галереи
	 *
	 * @memberof Gallery
	 */
	hendlerClickEdge() {
		this.galleryOverlay.addEventListener('click', () => {
			if (this.getFullscreenState()) {
				this.toggleFullscreen();
			}
		});
	}

	/**
	 * Intersection Observer, который выполняет функцию обновления данных при попадании в его область видимости элемента коллекции.
	 *
	 * @memberof Gallery
	 */
	handlerOvserver() {
		const options = {
			root: this.gallery,
			rootMargin: '0px',
			threshold: 1.0,
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					this.setCurrentSlide(entry.target.dataset.id);
					this.setPreview(this.currentSlide);
					this.setText(this.currentSlide);
					this.setDot(this.currentSlide);
					this.canClickArrowButton(this.currentSlide, this.maxSlide - 1);
					this.setCounter();

					if (this.gallery.dataset.page) {
						// History Observer для страницы публикации типа "Галерея"
						new HistoryObserver({ root: this.gallery }, true, true).init();

						// Если инициализирован класс с индексом в URL страницы
						if (this.isStartOnPage) {
							const id = this.getUrlId();
							this.moveTo(id - 1);
							this.isStartOnPage = false;
						}
					}
				}
			});
		}, options);

		this.galleryListItems.forEach((item) => {
			observer.observe(item);
		});
	}
}

export default Gallery;
